import styled from "styled-components";

import StyledInfoCard from "./StyledInfoCard.styled";

const StyledInfoPage = styled.div`
  ${StyledInfoCard} {
    max-width: 504px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;
  }
`;

export default StyledInfoPage;
